<template>
  <baidu-map :center="center" :zoom="zoom" @ready="handler" style="height:100%" @click="getClickInfo" :scroll-wheel-zoom='true'>
  </baidu-map>
</template>
<script>
export default {
  name: 'TestBaiDu',
  data () {
    return {
      center: {lng: 114.7, lat: 30},
      zoom: 10
    }
  },
  props: {
    siteList: {
      type: Array,
      default: function () {
        return [];
      }
    }
  },
  methods: {
    handler ({BMap, map}) {
      let flag = 0
      this.siteList.forEach(siteMap => {
        if(siteMap.hasOwnProperty('latitude') && siteMap.hasOwnProperty('longitude')) {
          if (flag === 0) {
            this.center = {lng: siteMap.longitude, lat: siteMap.latitude}
            flag = 1
          }
          var point = new BMap.Point(siteMap.longitude, siteMap.latitude)
          var marker = new BMap.Marker(point, {strokeColor: "blue"})
          map.addOverlay(marker)
          var opts = {
            width: 100,
            height: 50
          }
          var infoWindow = new BMap.InfoWindow(siteMap.buildName, opts)
          marker.addEventListener('mouseover', function() {
            map.openInfoWindow(infoWindow, point)
          })
          marker.addEventListener('mouseout', function() {
            map.closeInfoWindow(infoWindow, point)
          })
        }
      });
      map.centerAndZoom(this.center, this.zoom)
      var mapStyle = {
        features: ["road", "building", "water", "land"],
        style: "dark"
      }
      this.$nextTick(() => {
        map.setMapStyleV2({styleId: 'fe7be58d2cef54565932a039c98dbf7f'});
        map.setMapStyle(mapStyle)
      })
    },
    getClickInfo (e) {
      // console.log(e.point.lng)
      // console.log(e.point.lat)
      // this.center.lng = e.point.lng
      // this.center.lat = e.point.lat
      // this.zoom = 8
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/common/map/CommonMap.vue